import React from "react";
import { BadgeIndianRupee, Banknote, Boxes, ChartNoAxesColumn, FileChartColumn, Landmark, ReceiptText, Users } from "lucide-react";
import PremiumHubPage from "../../../Components/Dashboard/PremiumHubPage";

const Reports = ({ navigation }) => {
  const go = (route) => () => navigation.navigate(route);

  return (
    <PremiumHubPage
      title="Reports"
      subtitle="Analyze sales, purchase, cash flow, receivables, payables, and financial statements."
      sections={[
        {
          title: "Business Overview",
          items: [
            { label: "Profit and Loss", description: "Income, expenses, and net profit.", icon: FileChartColumn, tone: "blue", onClick: go("ProfitAndLoss") },
            { label: "Balance Sheet", description: "Assets, liabilities, and equity.", icon: Landmark, tone: "green", onClick: go("BalanceSheet") },
            { label: "Cash Statement", description: "Cash movement and balances.", icon: Banknote, tone: "orange", onClick: go("CashStatement") },
            { label: "Business Ratios", description: "Key performance ratios.", icon: ChartNoAxesColumn, tone: "blue", onClick: go("BusinessPerfomanceRatios") },
          ],
        },
        {
          title: "Sales Reports",
          items: [
            { label: "Sales by Customer", description: "Customer-wise sales performance.", icon: Users, tone: "blue", onClick: go("SalesCustomer") },
            { label: "Sales by Items", description: "Item-wise sales summary.", icon: Boxes, tone: "green", onClick: go("SalesItems") },
            { label: "Sales by Invoice", description: "Invoice-level sales detail.", icon: ReceiptText, tone: "orange", onClick: go("SalesByInvoice") },
            { label: "Sales by Salesperson", description: "Team contribution and revenue.", icon: Users, tone: "red", onClick: go("SalesBySalesperson") },
          ],
        },
        {
          title: "Receivables & Payables",
          items: [
            { label: "Receivable Summary", description: "Customer receivables overview.", icon: BadgeIndianRupee, tone: "green", onClick: go("ReceivableSummary") },
            { label: "Receivable Details", description: "Invoice aging and collections.", icon: ReceiptText, tone: "blue", onClick: go("ReceivableDetails") },
            { label: "Payable Summary", description: "Vendor payable overview.", icon: BadgeIndianRupee, tone: "orange", onClick: go("PayableSummary") },
            { label: "Payable Details", description: "Bill aging and obligations.", icon: ReceiptText, tone: "red", onClick: go("PayableDetails") },
          ],
        },
      ]}
    />
  );
};

export default Reports;
